import { useEffect, useState } from "react";
import Card from "../Card";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "src/base-components/Button";
import { selectCustomerInfo } from "src/stores/calllogs";
import ViewQueryModal from "./callAnswered/ViewQueryModal";

export const ExistingQuery = ({
  selectedQuery,
  onSelect,
  disabled = false,
  hideSelect = false,
  code,
  currentQueryValue,
}: {
  selectedQuery?: any; // optional
  onSelect?: (q: any) => void;
  disabled?: boolean;
  hideSelect?: boolean;
  code?: string;
  currentQueryValue?: string | null;
}) => {
  const [openViewModal, setOpenViewModal] = useState<boolean>(false);
  const [getqueryID, setGetQueryID] = useState<string | null>(null);

  const navigate = useNavigate();
  const customerInfo = useSelector(selectCustomerInfo);
  const result = customerInfo?.data?.result;

  // Safely extract queries and customer
  const existingQueries = result?.queries ?? [];
  useEffect(() => {
    console.log(
      existingQueries,
      "existingQueriesexistingQueriesexistingQueriesexistingQueries"
    );
  }, [existingQueries]);
  const customer = result?.customer ?? null;
  const normalizedCode = String(code || "")
    .trim()
    .toLowerCase();

  console.log(normalizedCode, "normalizedCodenormalizedCodenormalizedCode");

  const codeForcesHide = code ? normalizedCode !== "answered" : false;

  console.log(codeForcesHide, "codeForcesHidecodeForcesHidecodeForcesHide");

  const handleClose = () => {
    setGetQueryID(null);
    setOpenViewModal(false);
  };

  const shouldDisable =
    currentQueryValue !== undefined && String(currentQueryValue).trim() !== "";
  return (
    <>
      <div className="space-y-4">
        <h4 className="font-medium text-gray-900  text-lg">
          Choose Existing Query
        </h4>
        <div
          className={`grid grid-cols-2 gap-3 max-h-[320px] ${
            existingQueries &&
            existingQueries?.length > 2 &&
            "overflow-y-auto pr-2"
          }`}
        >
          {existingQueries?.map((query) => {
            const paxCount =
              (query?.no_of_adults ?? 0) +
              (query?.no_of_children ?? 0) +
              (query?.no_of_infants ?? 0);
            const isSelected = selectedQuery?.id === query.id;
            return (
              <Card
                key={query.id}
                className={`p-3 cursor-pointer transition-all ${
                  isSelected
                    ? "border-blue-500 bg-blue-50"
                    : "border-gray-200 hover:border-gray-300"
                }`}
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="font-medium text-blue-600">
                    {query.query_no}
                  </span>
                  <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                    {query.stage_text}
                  </span>
                </div>
                <p className="text-sm text-gray-900 mb-1">
                  {customer?.fullname}
                </p>
                <div className="flex justify-between text-xs text-gray-500">
                  <span>Customer ID: {customer?.customer_id}</span>
                  <span>No. of PAX: {paxCount}</span>
                </div>
                <div
                  className={`flex ${
                    hideSelect || codeForcesHide
                      ? "justify-end"
                      : "justify-between"
                  } mt-3`}
                >
                  {normalizedCode === "answered" && (
                    <button
                      type="button"
                      className={`w-fit ${
                        isSelected
                          ? "border border-blue-500 bg-blue-50"
                          : "bg-[#233580] text-white"
                      } ${
                        shouldDisable && !isSelected
                          ? "bg-gray-500 cursor-not-allowed"
                          : ""
                      } p-2 rounded-lg text-xs font-medium`}
                      onClick={() => {
                        // Prevent selecting when disabled, but allow unselecting
                        if (shouldDisable && !isSelected) return;
                        onSelect?.(isSelected ? null : query);
                      }}
                      disabled={shouldDisable && !isSelected}
                    >
                      {isSelected ? "Unselect" : "Select"}
                    </button>
                  )}

                  <button
                    type="button"
                    className="w-fit bg-[#233580] text-white p-2 rounded-lg text-xs font-medium"
                    onClick={() => {
                      setOpenViewModal(true);
                      setGetQueryID(query.id);
                    }}
                  >
                    View
                  </button>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
      <ViewQueryModal
        openViewModal={openViewModal}
        getqueryID={getqueryID}
        handleClose={handleClose}
      />
    </>
  );
};
